import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import TableCasino from '../../../../../../@casino/ui/table';
import { setGetMailingStatisticsScrollerUsersDepositsByCurrency } from '../../../../../store/mailing/thunk/setGetMailingStatisticsScrollerUsersDepositsByCurrency';

const CountUsersDeposits = ({
    id,
    currency
}) => {

    const dispatch = useDispatch();

    React.useEffect(() => {
        dispatch(setGetMailingStatisticsScrollerUsersDepositsByCurrency({
            mailing_id: id,
            currency,
            page: 1,
            pageSize: 25,
            status: 'paid'
        }))
    }, []);

    const deposits_by_currency = useSelector((state) => state.mailing.scrollers.deposits_users_by_currency);

    const columns = [
        { id: 'login', label: 'Логин'},
        { id: 'total_count', label: 'Кол-во депозитов'},
        { id: 'total_sum', label: 'Сумма депозитов'},
        { id: 'currency', label:  'Валюта'}
    ];

    const handleChange = ({
        page,
        pageSize
    }) => {
        dispatch(setGetMailingStatisticsScrollerUsersDepositsByCurrency({
            mailing_id: id,
            currency,
            page,
            pageSize,
            status: 'paid'
        }))
    }

    return (
        <div>
            <div>
                <h3 style={{
                    color: "#FFFFFF",
                    fontWeight: 700,
                }}>Количество и сумма депозитов {currency}</h3>
            </div>
            <div style={{borderRadius: 12, background: 'rgb(24, 32, 58)', padding: 20}}>
                <TableCasino
                    width={"100%"}
                    pagination
                    allPage={deposits_by_currency.totalPage}
                    perPage={deposits_by_currency.pageSize}
                    columns={columns}
                    rows={deposits_by_currency.list.map((item) => ({
                        ...item,
                        total_sum: new Intl.NumberFormat('ru-RU').format(item.total_sum),
                        total_count: new Intl.NumberFormat('ru-RU').format(item.total_count),
                    }))}
                    changePage={(v) => {
                        handleChange({
                            page: v.page + 1,
                            pageSize: v.rowsPerPage
                        })
                    }}
                    changeRowsPerPage={(v) => {
                        handleChange({
                            page: 1, 
                            pageSize: v.rowsPerPage,
                        })
                    }}
                />
            </div>
            
        </div >
    )
}

export default CountUsersDeposits;